export default {
  prefixCls: 'react-button-loaders'
}



// WEBPACK FOOTER //
// ./src/lib/config.js